module.exports = __webpack_public_path__ + "img/feature_8.980005e7.svg";